export const TASK_UNAVAILABLE_TITLE = 'Zadatak nije dostupan';

export const TASK_UNAVAILABLE_MESSAGE =
  'Ovaj zadatak je obrisan ili vam više nije dodijeljen. Uradite dolaznu sinhronizaciju zadataka.';

const TASK_UNAVAILABLE_OPERATION_TYPES = [
  'CREATE_COMMENT',
  'CREATE_DOCUMENT',
  'CREATE_TASK_EXECUTION',
  'UPDATE_TASK_STATUS',
];

const TASK_UNAVAILABLE_STORE_NAMES = [
  'tasks_comments',
  'tasks_documents',
  'tasks_execution',
  'tasks_distribution',
  'distribution_execution',
  'tasks_status',
];

const getErrorText = (error) => {
  if (!error) return '';

  return [
    error.message || '',
    error.networkError?.message || '',
    error.response?.data?.error || '',
    error.response?.data?.message || '',
    ...(error.graphQLErrors || []).map((err) => err.message || ''),
  ]
    .join(' ')
    .toLowerCase();
};

export const isTaskOperationContext = (context) => {
  if (!context) return false;

  const operationType = context.type || context.operationType;
  const storeName = context.storeName;

  return (
    TASK_UNAVAILABLE_OPERATION_TYPES.includes(operationType) ||
    TASK_UNAVAILABLE_STORE_NAMES.includes(storeName)
  );
};

export const isTaskUnavailableError = (error, context = null) => {
  const text = getErrorText(error);
  if (!text) return false;

  const isOracleParentKeyError =
    text.includes('ora-02291') && text.includes('parent key not found');

  return (
    text.includes(TASK_UNAVAILABLE_MESSAGE.toLowerCase()) ||
    text.includes('fk_texec_task_subject') ||
    text.includes('nevažeći task-subjekt id') ||
    text.includes('nevazeci task-subjekt id') ||
    (isOracleParentKeyError && isTaskOperationContext(context)) ||
    (text.includes('createtaskexecution') &&
      text.includes('parent key not found')) ||
    (text.includes('createtaskscomment') &&
      text.includes('parent key not found')) ||
    (text.includes('tasksubjectid') && text.includes('parent key not found'))
  );
};

export const getTaskUnavailableMessage = (error, context = null) => {
  return isTaskUnavailableError(error, context)
    ? TASK_UNAVAILABLE_MESSAGE
    : null;
};
